module.exports = __webpack_public_path__ + "static/img/login_tip.c1ed96c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_tip.png
// module id = ju9j
// module chunks = 1